import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import type { IAuthContext } from "./IAuthContext";

export function useAuth(): IAuthContext {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider.");
  }

  return context;
}
